/* global VeloxWebView, VeloxViewController */
var ActivationController = VeloxViewController.create({
    directory : "views/login",
    name: "activate",
    container: "main",
    route: "activate"
}) ;

ActivationController.prototype.prepareDataOnEnter = function(token, callback){
    this.api.public.getLang(token, function(err, lang){
        if(err){ callback(err) ;}
        if(lang){
            VeloxWebView.i18n.setLang(lang) ;
        }
        callback(null, {
            token: token 
        });
    }) ;
};

ActivationController.prototype.focusLogin = function(){
    this.view.focusLogin() ;
};

ActivationController.prototype.onValidate = function(){
    this.view.updateData() ;

    this.view.longTask(function(done){
        this.api.activateUser(this.data.token, this.data.passwordNew, this.data.login, true, function(err){
            if(err){ 
                return done(null, err);
            }
            this.navigate("/download") ;
            window.location.reload() ;
        }.bind(this)) ;
    }.bind(this), function(err1, err){
        if(err === 'INVALID_TOKEN'){ 
            return this.view.error(this.view.tr("login.invalidToken"))  ;
        }else if(err === 'LOGIN_ALREADY_EXISTS'){ 
            return this.view.error(this.view.tr("login.loginAlreadyExists"))  ;
        }else if(err === 'ALREADY_ACTIVE'){ 
            this.view.question(VeloxWebView.tr("login.alreadyActiveWhatToDo"),
                {size: "medium"},
                [
                    {label: VeloxWebView.tr("login.downloadApplication"), code: "connect", className: "btn-primary"},
                    {label: VeloxWebView.tr("login.forgotPasswordWantRenew"), code: "forgot", className: "btn-outline-primary"}
                ], function(answer){
                    if(answer === "connect"){
                        this.navigate("/download");
                        window.location.reload() ;
                        return ;
                    } else if(answer === "forgot"){
                        return this.navigate("/forgot");
                    }
                }.bind(this)) ;
            return   ;
        }
    }.bind(this)) ;
} ;


module.exports = new ActivationController() ;